// 标识颜色定义
export const exerciseTypeColor = {
  // 1-热身，2-训练，3-放松，4-休息
  1: '#ffaa00',
  2: '#1eba1e',
  3: '#00d5ff',
  4: '#B3C1E0'
  // 4: 'transparent'
};

// 标识颜色定义
export const modeColor = {
  // 0:普通运动自动记圈
  // 1:普通运动手动记圈
  // 2:间隙运动的训练
  // 3:间隙运动的休息
  // 4:间隙运动的热身
  // 5:间隙运动的放松
  // 10:gomore运动的热身
  // 11:gomore运动的训练
  // 12:gomore运动的放松
  // 13:为了兼容佳明，游泳的休息趟，不在显示在圈里面，在趟里面也不显示
  // 14:动作的训练
  // 15:动作的休息，休息可有可无
  // 16:动作多组训练汇总圈
  // 17:动作多组休息汇总圈, 休息可有可无
  // 32:按照用户设置的圈距自动记圈
  // 64:手动记圈
  // 128:骑行(5km)或者跑步(1km)的默认圈只有普通运动才有的

  0: 'transparent',
  1: 'transparent',
  2: '#1eba1e',
  3: '#B3C1E0',
  4: '#ffaa00',
  5: '#00d5ff',
  10: '#ffaa00',
  11: '#1eba1e',
  12: '#00d5ff',
  13: '#B3C1E0',
  14: '#1eba1e',
  15: '#B3C1E0',
  16: '#1eba1e',
  17: 'transparent',
  32: 'transparent',
  64: 'transparent',
  128: 'transparent'
};
